var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    {
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "LinkItem",
                _vm._g(
                  {
                    key: "export_csv",
                    attrs: {
                      text: "Export as CSV",
                      icon: "mdi-file-delimited",
                    },
                    on: { click: _vm.showModal },
                  },
                  on
                )
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.showingModal,
        callback: function ($$v) {
          _vm.showingModal = $$v
        },
        expression: "showingModal",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v(" Export as CSV "),
          ]),
          _c(
            "v-card-text",
            [
              _c("v-select", {
                attrs: {
                  items: _vm.fields,
                  label: "Select Fields",
                  dense: "",
                  multiple: "",
                  hint: "Pick the fields to export",
                },
                model: {
                  value: _vm.fieldsToAdd,
                  callback: function ($$v) {
                    _vm.fieldsToAdd = $$v
                  },
                  expression: "fieldsToAdd",
                },
              }),
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.rows,
                  "items-per-page": 5,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.Title`,
                      fn: function ({ item }) {
                        return [_vm._v(_vm._s(_vm.truncate(item.Title)))]
                      },
                    },
                    {
                      key: `item.Message`,
                      fn: function ({ item }) {
                        return [_vm._v(_vm._s(_vm.truncate(item.Message)))]
                      },
                    },
                    {
                      key: `item.Description`,
                      fn: function ({ item }) {
                        return [_vm._v(_vm._s(_vm.truncate(item.Description)))]
                      },
                    },
                    {
                      key: `item.Descriptions`,
                      fn: function ({ item }) {
                        return [_vm._v(_vm._s(_vm.truncate(item.Descriptions)))]
                      },
                    },
                    {
                      key: `item.Code`,
                      fn: function ({ item }) {
                        return [
                          _vm._v(
                            _vm._s(_vm.truncate(item.Code.replace(/=/g, "")))
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.Check`,
                      fn: function ({ item }) {
                        return [_vm._v(_vm._s(_vm.truncate(item.Check)))]
                      },
                    },
                    {
                      key: `item.Fix`,
                      fn: function ({ item }) {
                        return [_vm._v(_vm._s(_vm.truncate(item.Fix)))]
                      },
                    },
                    {
                      key: `item.Segments`,
                      fn: function ({ item }) {
                        return [_vm._v(_vm._s(_vm.truncate(item.Segments)))]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { text: "" }, on: { click: _vm.closeModal } },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", text: "" },
                  on: { click: _vm.exportCSV },
                },
                [_vm._v(" Export ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }